import { useState ,useEffect} from "react";
import { Info } from "lucide-react";
import { commonComponents as cc } from '@/components/common';
import AuthWrap from '@/features/auth/components/AuthWrap';
import SmartAuthForm from '@/features/auth/components/SmartAuthForm';
import Banner from '@/components/common/Banner';

export function AuthErrorPage({ resetAuthError }: { resetAuthError: () => void }) {

	const [showBanner, setShowBanner] = useState(true);
	
	return (
		<>
			<Banner
				className="bg-gradient-to-tl from-sky-50/80 to-indigo-100/80 shadow-sm border-indigo-200/60"
				show={showBanner}
				setShow={setShowBanner}
			>
				<div className="flex items-center gap-3 py-1">
					<Info className="flex-shrink-0 w-5 h-5 text-sky-600 dark:text-sky-200" aria-hidden="true" />
					<span className="font-medium text-sky-700 dark:text-sky-200">
						This link has expired but not to worry! Please confirm your account by entering your email.
					</span>
		</div>
			</Banner>
			<AuthWrap>
				<cc.Title words="Sign up / Sign in" />
				<SmartAuthForm onSuccess={resetAuthError} />
			</AuthWrap>
		</>
	);
}
